(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("FlyersImportHubController", FlyersImportHubController);

    function FlyersImportHubController($window, $scope, $localStorage, $sessionStorage, $stateParams, $state, $translate,
                                       paginationConstants, toastr, HubFlyersService, BrandService, systemConstants, StoreService,
                                       flyersConstants, $uibModal, MODAL_CONTENT_TYPES) {
        var vm = this;

        vm.$onInit = init;
        vm.isBrandSelected = isBrandSelected;
        vm.selectBrand = selectBrand;
        vm.nextStep = nextStep;
        vm.loadBrands = loadBrands;
        vm.clearPaginationInfo = clearPaginationInfo;
        vm.notSelectedAny = notSelectedAny;
        vm.countSelected = countSelected;
        vm.goBack = goBack;
        vm.listCategoryFilterOptions = HubFlyersService.listCategoryFilterOptions;

        vm.isLoading = false;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;

        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.sortOptions = paginationConstants.importHubSortOptions[$translate.use().toLowerCase()];
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.maxSize = 5;
        vm.totalBrands = 0;
        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.brands = [];
        vm.selectedBrands = [];
        vm.totalBrands = undefined;
        vm.isImmoContext = false;
        // TODO refatorar seleção multipla de brands para ficar padronizado de acordo com o restante dos filtros
        //  multi-select com opção de "selecionar todos"
        vm.selectedBrands = {
            brands: [],
            allBrands: false,
            excludedBrands: []
        };
        vm.numberFilterSelected = 0;

        vm.brandFilter = {
            brandName: '',
            brandFirstLetter: '',
            activated: null,
            storeId: $localStorage.defaultStore.storeId,
            sortBy: 'brand',
            sortDirection: 'asc',
            type: $stateParams.type ? $stateParams.type : null,
            configurations: [],
            launch: undefined,
            basic: undefined,
            delivered: undefined,
            colors: [],
            sizes: [],
            bedrooms: [],
            genders: [],
            minValue: null,
            maxValue: null,
            region: [],
            categoryKeys: [],
            categoryKey: undefined,
            brand: null,
            brands: []
        };

        vm.bedrooms = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        vm.selectedLetter = null;
        vm.dynamicFilterOptions = {
            categories: getDynamicFilterOptionsModel(),
            brands: getDynamicFilterOptionsModel(),
            colors: getDynamicFilterOptionsModel(),
            sizes: getDynamicFilterOptionsModel()
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.dynamicFilterOptions.categories.model, function (el) {
                return el.key === flyer.categoryKey
            });
            if (category) {
                flyer.category = category.title;
            }
        }

        function onLetterSelected() {
            vm.filters.brandFirstLetter = !vm.selectedLetter ? '' : vm.selectedLetter;
            clearPaginationInfo();
            loadBrands();
        }

        vm.scrollAlphabet = function (direction) {
            var container = document.getElementById('alphabetScroll');
            var scrollAmount = 100;

            if (direction === 'left') {
                container.scrollLeft -= scrollAmount;
            } else {
                container.scrollLeft += scrollAmount;
            }
        };

        vm.selectedSortByOption = {
            value: vm.brandFilter.sortBy,
            direction: vm.brandFilter.sortDirection
        };

        var WITH_STOCK = 'WITH_STOCK';
        var OUT_OF_STOCK = 'OUT_OF_STOCK';

        vm.selectionTypesData = {
            currentSelection: 'NONE',
            'ALL': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllFromHub();
                }
            },
            'ALL_FROM_PAGE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllItems();
                }
            },
            'NONE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.unselectAll();
                }
            }
        };

        function initializeMassSelectionActionsOptions() {
            vm.selectionTypes = [
                {
                    value: 'ALL',
                    translation: 'flyers.import-hub.mass-select.all-from-hub'
                },
                {
                    value: 'ALL_FROM_PAGE',
                    translation: 'flyers.selection-filters.select-all-from-page'
                },
                {
                    value: 'NONE',
                    translation: 'flyers.selection-filters.select-none'
                }
            ];
        }

        vm.getSelectionTypes = function () {
            return vm.selectionTypes.filter(function(type) {
                return type.value !== WITH_STOCK && type.value !== OUT_OF_STOCK;
            });
        };

        vm.filters = {
            region: [],
            categories: [],
            colors: [],
            sizes: [],
            genders: [],
            bedrooms: [],
            configurations: [],
            minValue: null,
            maxValue: null
        };

        vm.isImmoContext = $localStorage.defaultStore.immoContext;

        function init() {
            loadBrands();
            initializeMassSelectionActionsOptions();
            vm.configurations = getConfigurationsValues();

            $scope.$watch('vm.selectedLetter', function (value) {
                onLetterSelected(value);
            });
        }

        function clearPaginationInfo() {
            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        function getFiltersNumber() {
            vm.numberFilterSelected =
                calculateDynamicFilterSelectedCount(vm.brandFilter.categories, vm.dynamicFilterOptions.categories) +
                calculateDynamicFilterSelectedCount(vm.brandFilter.brands, vm.dynamicFilterOptions.brands) +
                calculateDynamicFilterSelectedCount(vm.brandFilter.colors, vm.dynamicFilterOptions.colors) +
                calculateDynamicFilterSelectedCount(vm.brandFilter.sizes, vm.dynamicFilterOptions.sizes) +
                (vm.brandFilter.region && vm.brandFilter.region.length || 0) +
                (vm.brandFilter.genders && vm.brandFilter.genders.length || 0) +
                (vm.brandFilter.configurations && vm.brandFilter.configurations.length || 0) +
                (Array.isArray(vm.brandFilter.bedrooms) ? vm.brandFilter.bedrooms.length : 0) +
                (Array.isArray(vm.brandFilter.bathrooms) ? vm.brandFilter.bathrooms.length : 0) +
                (vm.brandFilter.minMeters && vm.brandFilter.maxMeters ? 1 : 0) +
                (Array.isArray(vm.brandFilter.parkingSpots) ? vm.brandFilter.parkingSpots.length : 0) +
                (vm.brandFilter.minValue && vm.brandFilter.maxValue ? 1 : 0) +
                (vm.brandFilter.sinceDate && vm.brandFilter.untilDate ? 1 : 0);
        }

        function calculateDynamicFilterSelectedCount(dynamicFilterModel, dynamicFilterOptions) {
            var selectedCount = 0;
            if (angular.isArray(dynamicFilterModel)) {
                selectedCount = dynamicFilterModel.length;
            } else if (angular.isObject(dynamicFilterModel)) {
                if (dynamicFilterOptions.selectAllOption) {
                    if (dynamicFilterModel.all) {
                        selectedCount = dynamicFilterOptions.totalItems - dynamicFilterModel.except.length;
                    } else {
                        selectedCount = dynamicFilterModel.only.length;
                    }
                } else {
                    selectedCount = dynamicFilterModel.only ? dynamicFilterModel.only.length : 0;
                }
            }
            return selectedCount;
        }

        function loadBrands() {
            if (!vm.isLoading) {
                vm.isLoading = true;

                if (vm.filters.configurations && (vm.filters.configurations).includes("launch")) {
                    vm.filters.launch = true;
                } else {
                    delete vm.filters.launch;
                }

                if (vm.filters.configurations && (vm.filters.configurations).includes("basic")) {
                    vm.filters.basic = true;
                } else {
                    delete vm.filters.basic;
                }

                if (vm.filters.configurations && (vm.filters.configurations).includes("delivered")) {
                    vm.filters.delivered = true;
                } else {
                    delete vm.filters.delivered;
                }

                if (!vm.filters.brandName || vm.filters.brandName.length === 0) {
                    delete vm.filters.brandName;
                }

                if (!vm.filters.brandFirstLetter || vm.filters.brandFirstLetter.length === 0) {
                    delete vm.filters.brandFirstLetter;
                }

                if (!vm.filters.activated || vm.filters.activated.length === 0) {
                    delete vm.filters.activated;
                }

                if (!vm.filters.type || vm.filters.type.length === 0) {
                    delete vm.filters.type;
                }

                if (!vm.filters.configurations || vm.filters.configurations.length === 0) {
                    delete vm.filters.configurations;
                }

                if (!vm.filters.launch || vm.filters.launch.length === 0) {
                    delete vm.filters.launch;
                }

                if (!vm.filters.basic || vm.filters.basic.length === 0) {
                    delete vm.filters.basic;
                }

                if (!vm.filters.delivered || vm.filters.delivered.length === 0) {
                    delete vm.filters.delivered;
                }

                if (!vm.filters.colors || vm.filters.colors.length === 0) {
                    delete vm.filters.colors;
                }

                if (!vm.filters.sizes || vm.filters.sizes.length === 0) {
                    delete vm.filters.sizes;
                }

                if (!vm.filters.bedrooms || vm.filters.bedrooms.length === 0) {
                    delete vm.filters.bedrooms;
                }

                if (!vm.filters.genders || vm.filters.genders.length === 0) {
                    delete vm.filters.genders;
                }

                if (!vm.filters.minValue || vm.filters.minValue.length === 0) {
                    delete vm.filters.minValue;
                }

                if (!vm.filters.maxValue || vm.filters.maxValue.length === 0) {
                    delete vm.filters.maxValue;
                }

                if (!vm.filters.region || vm.filters.region.length === 0) {
                    delete vm.filters.region;
                }

                if (!vm.filters.categories || vm.filters.categories.length === 0) {
                    delete vm.filters.categories;
                }

                if (!vm.filters.categoryKeys || vm.filters.categoryKeys.length === 0) {
                    delete vm.filters.categoryKeys;
                }

                if (!vm.filters.categoryKey || vm.filters.categoryKey.length === 0) {
                    delete vm.filters.categoryKey;
                }

                if (!vm.filters.categorySelection ||
                    (!vm.filters.categorySelection.all && vm.filters.categorySelection.only.length === 0)) {
                    delete vm.filters.categorySelection;
                }

                if (!vm.filters.brand || vm.filters.brand.length === 0) {
                    delete vm.filters.brand;
                }

                if (!vm.filters.brands || vm.filters.brands.length === 0) {
                    delete vm.filters.brands;
                }

                if(vm.filters.sortBy) {
                    vm.filters.sortBy = "brand"
                }
                getFiltersNumber();
                HubFlyersService.findBrands(vm.paginationOptions, vm.filters, onSuccessLoadBrands, onErrorLoadBrands);
            }
        }

        function onSuccessLoadBrands(data) {
            if (data.content) {
                vm.brands = angular.copy(data.content);
            }
            mapSelectedBrands(vm.brands);

            if (data.totalElements) {
                vm.totalBrands = data.totalElements;
                getPageCurrentValue();
            }
            vm.isLoading = false;
        }

        function onErrorLoadBrands() {
            vm.isLoading = false;
            toastr.error($translate.instant('flyers.messages.load.error'));
        }

        function isBrandSelected(brand) {
            var selectedBrandIndex = vm.selectedBrands.brands.findIndex(function (selectedBrand) {
                return selectedBrand.brand === brand.brand
            })

            var excludedBrandIndex = vm.selectedBrands.excludedBrands.findIndex(function (selectedBrand) {
                return selectedBrand.brand === brand.brand
            })

            return (vm.selectedBrands && Array.isArray(vm.selectedBrands.brands) && selectedBrandIndex !== -1)
                || (vm.selectedBrands.allBrands && excludedBrandIndex === -1);
        }

        function hasBrandWithName(brandsArray, nameToFind) {
            for (var i = 0; i < brandsArray.length; i++) {
                if (brandsArray[i].brand === nameToFind) {
                    return true;
                }
            }
            return false;
        }

        function selectBrand(brand) {
            vm.brandFilter = vm.brandFilter || {};
            vm.selectedBrands.brands = vm.selectedBrands.brands || [];
            vm.selectedBrands.excludedBrands = vm.selectedBrands.excludedBrands || [];

            if (vm.selectedBrands.allBrands) {
                const index = vm.selectedBrands.excludedBrands.indexOf(brand);
                if (index === -1 && !hasBrandWithName(vm.selectedBrands.excludedBrands, brand.brand) ) {
                    vm.selectedBrands.excludedBrands.push(brand);
                } else {
                    vm.selectedBrands.excludedBrands.splice(index, 1);
                }
            } else {
                const brandIndex = vm.selectedBrands.brands.indexOf(brand);
                if (brandIndex !== -1) {
                    vm.selectedBrands.brands.splice(brandIndex, 1);
                } else {
                    vm.selectedBrands.brands.push(brand);
                }
            }

            mapSelectedBrands(vm.brands);
        }

        function nextStep() {
            vm.brandFilter.brandSelection = vm.selectedBrands;
            $sessionStorage.hubImportDynamicFilterOptions = vm.dynamicFilterOptions;
            $sessionStorage.hubImportBrandFilter = vm.brandFilter;
            var hubImportMultiSelectFilters = angular.copy(vm.filters);
            delete hubImportMultiSelectFilters.brandName;
            delete hubImportMultiSelectFilters.brandFirstLetter;
            $sessionStorage.hubImportMultiSelectFilters = hubImportMultiSelectFilters;
            $state.go('flyers.import-hub.select-flyers')
        }

        function getPageCurrentValue() {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, vm.totalBrands);
        }

        vm.searchForTerm = function () {
            clearPaginationInfo();
            vm.loadBrands();
        }

        vm.changePage = function () {
            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.numPerPage;
            loadBrands();
            getPageCurrentValue();
            mapSelectedBrands(vm.brands);
        }

        vm.onChangeItemsPerPage = function (newValue) {
            clearPaginationInfo();
            vm.numPerPage = newValue;
            vm.changePage();
        };

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        vm.onSelectedSortOption = function (newValue) {
            clearPaginationInfo();
            vm.selectedSortByOption = newValue;
            vm.filters.sortDirection = vm.selectedSortByOption.direction;
            loadBrands();
        }

        vm.isAllFromPageSelected = function () {
            return vm.brands.length > 0 && vm.brands.every(function (brand) {
                return brand.__isSelected ? brand.__isSelected : false;
            });
        }

        vm.selectItemsBy = function (selectBy, isFromSelection) {
            isFromSelection = isFromSelection ? isFromSelection : false;
            if (selectBy === 'ALL_FROM_PAGE' && vm.isAllFromPageSelected() && !vm.isIndeterminate() && !isFromSelection) {
                vm.unselectAllFromPage();
                vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;
                vm.selectionTypesData.currentSelection = 'NONE'
                return;
            }

            if (isFromSelection && selectBy !== 'ALL_FROM_PAGE') {
                vm.unselectAll();
            }
            vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;

            vm.selectionTypesData[selectBy].selectFunc();

            vm.selectionTypesData.currentSelection = selectBy;
            vm.selectionTypesData[selectBy].isActivated = true;
        }

        vm.isIndeterminate = function () {
            var filteredSelected = vm.brands.filter(function (brand) {
                return brand.__isSelected ? brand.__isSelected : false
            });
            return vm.selectedBrands.brands.length > 0
                && filteredSelected.length >= 1
                && filteredSelected.length !== vm.brands.length;
        }

        vm.unselectAllFromPage = function () {
            vm.brands.forEach(function (brand) {
                var index = vm.selectedBrands.brands.findIndex(function (b) {
                    return b.brand === brand.brand;
                });
                if (index !== -1) {
                    vm.selectedBrands.brands.splice(index, 1);
                }
            });
            mapSelectedBrands(vm.brands);
        };

        vm.unselectAll = function () {
            vm.selectedBrands.excludedBrands = [];
            vm.selectedBrands.brands = [];
            vm.selectedBrands.allBrands = false;
            vm.selectedBrands.brands.forEach(function (brand) {
                brand.__isSelected = false;
            });
            mapSelectedBrands(vm.brands);
        }

        vm.selectAllItems = function () {
            if (vm.selectedBrands.allBrands) {
                vm.selectedAll = vm.selectedBrands.allBrands;

                if (vm.selectedBrands.excludedBrands.length > 0) {
                    vm.selectedBrands.excludedBrands = [];
                } else {
                    angular.forEach(vm.brands, function (brand) {
                        if (vm.selectedBrands.excludedBrands.indexOf(brand) === -1) {
                            vm.selectedBrands.excludedBrands.push(brand);
                        }
                    });
                }
            } else {
                vm.selectedAll = !vm.isAllFromPageSelected();

                angular.forEach(vm.brands, function (brand) {
                    if (vm.selectedAll) {
                        if (vm.selectedBrands.brands.indexOf(brand) === -1) {
                            vm.selectedBrands.brands.push(brand);
                        }
                    } else {
                        if (vm.selectedBrands.brands.indexOf(brand) !== -1) {
                            vm.selectedBrands.brands.splice(vm.selectedBrands.brands.indexOf(brand), 1);
                        }
                    }
                });
            }

            mapSelectedBrands(vm.brands);
        };

        vm.selectAllFromHub = function () {
            vm.selectedBrands.allBrands = true;
            mapSelectedBrands(vm.brands);
        }

        vm.loadFilter = function (filterType, listKey, singleKey, valueKey, paginatedSelectionKey) {
            var filterOptions = vm.brandFilter[filterType];

            if (angular.isArray(filterOptions)) {
                if (filterOptions.length > 0) {
                    var formatedList = filterOptions.map(function (item) {
                        return item[valueKey];
                    });

                    vm.filters[listKey] = formatedList;

                    if (singleKey && formatedList.length > 0) {
                        vm.filters[singleKey] = formatedList[0];
                    }
                } else {
                    delete vm.filters[listKey];
                    if (singleKey) {
                        delete vm.filters[singleKey];
                    }
                }
            } else {
                if (paginatedSelectionKey) {
                    var formatedPaginatedSelection = angular.copy(filterOptions);
                    formatedPaginatedSelection.except = formatedPaginatedSelection.except.map(function (item) {
                        return item[valueKey];
                    });
                    formatedPaginatedSelection.only = formatedPaginatedSelection.only.map(function (item) {
                        return item[valueKey];
                    });

                    vm.filters[paginatedSelectionKey] = formatedPaginatedSelection;
                } else {
                    delete vm.filters[paginatedSelectionKey];
                }
            }
            clearPaginationInfo();
            loadBrands();
        };

        function getConfigurationsValues() {
            var configurations = [
                {id: 1, label: "flyers.new.form.configurations.launch", code: "launch"},
                {id: 2, label: vm.getTranslateKey('flyers.new.form.configurations.basic'), code: "basic"}
            ];

            if (vm.isImmoContext) {
                configurations.push(
                    {id: 3, label: "flyers.new.form.configurations.delivered", code: "delivered"}
                );
            }

            return configurations;
        }

        vm.openFiltersModal = function () {

            vm.filtersModal = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('flyers.filters.modalTitle'),
                            cancelButtonText: $translate.instant('flyers.button.cancel'),
                            confirmButtonText: $translate.instant('flyers.filters.apply'),
                            options: {
                                dynamicFilterOptions: vm.dynamicFilterOptions,
                                region: vm.region,
                                bedrooms: vm.bedrooms,
                                price: vm.price,
                                configurations: vm.configurations,
                                clearFilters: vm.clearFilters,
                                itemsPerPageOptions: vm.itemsPerPageOptions,
                                sortOptions: vm.sortOptions,
                                numPerPage: vm.numPerPage,
                                selectedSort: vm.selectedSortByOption,
                                listCategoryFilterOptions: function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listCategoryFilterOptions(pageable, search, onSuccess, onError);
                                },
                                listBrandFilterOptions: function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listBrandFilterOptions(pageable, search, onSuccess, onError);
                                },
                                listColorFilterOptions: function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listColorFilterOptions(pageable, search, onSuccess, onError);
                                },
                                listSizeFilterOptions : function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listSizeFilterOptions(pageable, search, onSuccess, onError);
                                }
                            },
                            filters: vm.brandFilter,
                            list: vm.filters,
                            isImmoContext: vm.isImmoContext,
                            type: MODAL_CONTENT_TYPES.FILTERS
                        }
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.filters = response.listFilter;
                    delete vm.filters.hasInventory;
                    vm.brandFilter = response.selectedFilters;
                    vm.filters.sortDirection = "asc";
                    clearPaginationInfo();

                    if (response.numPerPage && response.numPerPage !== vm.numPerPage) {
                        vm.onChangeItemsPerPage(response.numPerPage);
                    }

                    if (response.sortSelected && response.sortSelected !== vm.selectedSortByOption) {
                        vm.selectedSortByOption = response.sortSelected;
                        vm.filters.sortBy = vm.selectedSortByOption.value;
                        vm.filters.sortDirection = vm.selectedSortByOption.direction;
                    }
                    loadBrands();

                    if (response.dynamicFilterOptions) {
                        vm.dynamicFilterOptions.categories.model = response.dynamicFilterOptions.categories.model || [];
                        vm.dynamicFilterOptions.brands.model = response.dynamicFilterOptions.brands.model || [];
                        vm.dynamicFilterOptions.colors.model = response.dynamicFilterOptions.colors.model || [];
                        vm.dynamicFilterOptions.sizes.model = response.dynamicFilterOptions.sizes.model || [];
                    }
                }
            });
        }

        function mapSelectedBrands(brands) {
            if (brands) {
                brands.forEach(function (brand) {
                    brand.__isSelected = isBrandSelected(brand);
                })
            }
        }

        function notSelectedAny() {
            return !(vm.selectedBrands && (vm.selectedBrands.brands.length > 0 || vm.selectedBrands.allBrands));
        }

        function countSelected() {
            if (vm.selectedBrands.allBrands) {
                const count = vm.totalBrands - vm.selectedBrands.excludedBrands.length;

                if (count === 0) {
                    vm.selectedBrands.allBrands = false;
                    return '0 ' + $translate.instant('flyers.import-hub.mass-select.selected');
                }


                return count + ' ' + $translate.instant('flyers.import-hub.mass-select.selected');
            } else {
                const count = vm.selectedBrands.brands.length;

                if (count === 0) {
                    vm.selectedBrands.allBrands = false;
                }

                return count + ' ' + $translate.instant('flyers.import-hub.mass-select.selected');
            }
        }

        function goBack() {
            $state.go('flyers');
        }
        }
    })();
